import pdfIcon from "../icons/pdf.svg";

export default [
  {
    id: "terms-2025-1",
    icon: pdfIcon,
    label: "Aliados Coninsa - Regional Antioquia",
    url: "https://d2xt7650da4t25.cloudfront.net/s3fs-public/2025-07/ALIADOS%20CONINSA%20-%20ANTIOQUIA%20-%20T%C3%89RMINOS%20Y%20CONDICIONES.pdf?VersionId=ZxSNSZjpzyVt9Br3VyJ.vcCQPD6LdFve",
  },
];
